import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { pureComponent } from 'lib/pureComponent';
import React from 'react';
import { PinNew, Plan } from 'store/plan/types';

type Props = {
  pin: PinNew | undefined;
  plan: Pick<Plan, 'name'> | undefined;
  onPress?: () => void;
};

export const PinFieldDisplay: React.FC<Props> = pureComponent(
  ({ plan, onPress }) => {
    return (
      <CardRow
        value={plan?.name || ''}
        placeholder="No Pin"
        actionIconLeft={ICONS.LocationPinLight}
        actionIcon={ICONS.LocationPinLight}
        onActionLeft={onPress}
      />
    );
  },
);
